import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=3e8c2977&scoped=true"
import script from "./viewDetails.vue?vue&type=script&lang=js"
export * from "./viewDetails.vue?vue&type=script&lang=js"
import style0 from "./viewDetails.vue?vue&type=style&index=0&id=3e8c2977&prod&scoped=true&lang=css"
import style1 from "./viewDetails.vue?vue&type=style&index=1&id=3e8c2977&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8c2977",
  null
  
)

export default component.exports